export const signUtmParams = (link, router) => {
  const campaign = router.pathname.split('/')[1] !== "" ? router.pathname.split('/')[1] : "home";

  return `${link}?utm_source=devit-software&utm_medium=website&utm_campaign=${campaign}`
}